import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { I18nService, LazyloadService, UtilService } from '@dm/core';
import { Router } from '@angular/router';
import { TaskSComponent } from 'app/feature/monitor/task-s/task-s.component';
import { SWITCH } from 'app/config';

@Component({
    selector: 'app-task-result',
    templateUrl: './task-result.component.html',
    styleUrls: ['./task-result.component.scss'],
})
export class TaskResultComponent implements OnInit {
    /**
     * 任务类型
     */
    @Input() msgType: string;
    /**
     * 任务ID
     */
    @Input() taskId: string;
    /**
     * 任务名称
     */
    @Input() taskName: string;
    /**
     * 任务对象名称
     */
    @Input() objName: string;

    @Output() onClose = new EventEmitter<void>();

    get = this.i18nService.get;

    i18n = {
        nameLab: this.get('common.name_column', true),
        targetLab: this.get('monitor.task_target_label', true),
        excuteFailedLab1: this.get('common.createTask_run_failed_tip').split('{0}')[0],
        excuteFailedLab2: this.get('common.createTask_run_failed_tip').split('{0}')[1],
        taskCenterLab: this.get('common.taskCenter_title'),
        excuteSuccess: this.get('common.createTask_run_success_tip'),
        viewDetail_info: this.get('system.upgrade_task_start_viewDetail_info'),
    };

    constructor(
        private i18nService: I18nService,
        private utilService: UtilService,
        private router: Router,
        private lazyLoadService: LazyloadService,
    ) { }

    ngOnInit(): void {
        if (this.objName) {
            this.objName = this.utilService.encodeHTML(this.objName);
        }
    }

    jump(): void {
        if (SWITCH.IS_SIMPLE_MODE) {
            this.lazyLoadService.appendComponent(TaskSComponent, {
                taskId: this.taskId,
            });
        } else {
            this.router.navigate(['/monitor/task'], {
                queryParams: {
                    action: 'restoreRouteState',
                    actionParams: this.taskId,
                },
            });
        }
        this.onClose.emit();
    }

    replaceBlock(objName): string {
        return objName.replace(/ /g, '&nbsp;');
    }
}
